<script lang="ts" module>
	import type { Component } from "svelte";
	import type { ContentBlock, SavedContentBlock } from "@core/schema/ContentBlock.js";
	import { ContentType } from "@core/schema/ContentType.js";
	import { contentBlockSchemaMap as schemaMap } from "@core/schema/contentBlockSchemaMap.js";
	import BenefitsBlock from "./content-blocks/BenefitsBlock.svelte";
	import CkEditorBlock from "./content-blocks/CkEditorBlock.svelte";
	import ContactButton from "./content-blocks/ContactButton.svelte";
	import type { ContentBlockComponentProps } from "./content-blocks/ContentBlockComponentProps.js";
	import GalleryBlock from "./content-blocks/GalleryBlock.svelte";
	import ImageBannerBlock from "./content-blocks/ImageBannerBlock.svelte";
	import LinkBlock from "./content-blocks/LinkBlock.svelte";
	import QuotationBlock from "./content-blocks/QuotationBlock.svelte";
	import UnorderedList from "./content-blocks/UnorderedList.svelte";

	const componentMap: { [T in ContentType]: Component<ContentBlockComponentProps<T>> } = {
		[ContentType.CKEditor]: CkEditorBlock,
		[ContentType.Gallery]: GalleryBlock,
		[ContentType.ImageBanner]: ImageBannerBlock,
		[ContentType.Benefits]: BenefitsBlock,
		[ContentType.ContactButton]: ContactButton,
		[ContentType.Link]: LinkBlock,
		[ContentType.Quotation]: QuotationBlock,
		[ContentType.UnorderedList]: UnorderedList,
	};
</script>

<script lang="ts">
	const {
		block,
		lightboxId,
		align = "center",
	}: { block: SavedContentBlock | ContentBlock; lightboxId: string | undefined; align: "center" | "left" } = $props();
	const Component = $derived(componentMap[block.type]);
	const data = $derived(
		schemaMap[block.type].parse(typeof block.data === "string" ? JSON.parse(block.data) : block.data),
	);
</script>

{void (/* @ts-expect-error TypeScript limits reached. */ "")}
<Component {data} {lightboxId} {align} />
